import { z } from 'zod';
const verExpression = /^\d+\.\d+\.\d+$/;
export const VersionStringSchema = z.custom((str) => verExpression.test(str));
//# sourceMappingURL=version-string.js.map